import FirestoreCollection from "helpers/firebase/firestore/firestore_collection";
import CoreModel from "../core/core";

export default class LocaleGroup extends CoreModel {
  static collection = new FirestoreCollection("LocaleGroup", LocaleGroup, []);

  constructor(id, data) {
    super(id);
    data = data || {};
    this.group_key = data.group_key
    this.locales = data.locales || {};
  }
}
